import { PageHero } from '@/components/PageHero';
import { OrderRow } from '@/components/OrderRow';
import { RowSkeleton } from '@/components/Skeleton';
import { EmptyState } from '@/components/EmptyState';
import { useOrders } from '@/hooks/useOrders';
import type { TabKey } from '@/constants/tabs';
import styles from './Orders.module.scss';

export interface OrdersPageProps {
  onNavigate: (tab: TabKey) => void;
}

export function OrdersPage({ onNavigate }: OrdersPageProps) {
  const { orders, loading } = useOrders();

  return (
    <div className={styles.page}>
      <PageHero title="Your orders" subtitle="Every purchase and gift you've sent, in one place." />

      {loading ? (
        <div className={styles.list} role="status" aria-label="Loading orders">
          <RowSkeleton />
          <RowSkeleton />
          <RowSkeleton />
        </div>
      ) : orders.length === 0 ? (
        <EmptyState
          title="No orders yet"
          description="Buy some Stars or gift Premium to get started."
          actionLabel="Browse marketplace"
          onAction={() => onNavigate('market')}
        />
      ) : (
        <div className={styles.list}>
          {orders.map((order) => (
            <OrderRow key={order.id} order={order} />
          ))}
        </div>
      )}
    </div>
  );
}
